<!--
 * @Descripttion: 报表详情
 * @Author: zenghua.wang
 * @Date: 2021-05-13 10:13:44
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 15:27:47
-->
<template>
  <basicContainer>
    <el-form
      v-if="loading"
      :label-position="data.labelPosition || 'right'"
      :label-width="setPx(data.labelWidth) || '100px'"
      :label-suffix="data.labelSuffix || ''"
    >
      <el-row>
        <template v-for="(item, index) in data.list">
          <el-col
            v-if="hasAuth(item.option)"
            :md="item.option.span || 24"
            :xs="24"
            :offset="item.option.offset || 0"
            :key="index"
          >
            <component
              :is="`drag-${item.type}`"
              :id="item.prop"
              :label="item.label"
              :apiId="item.apiId"
              :width="item.width"
              :height="item.height"
              :option="item.option"
              :page="item.page"
              :children="item.children"
              :index="index"
              :disabled="true"
            ></component>
          </el-col>
        </template>
      </el-row>
    </el-form>

    <div
      v-if="noAuth"
      :style="styleNoAuth"
    >对不起，您没有权限查看！</div>
  </basicContainer>
</template>
<script>
/** 引入拖拽组件、属性设置组件 */
import '@/dragComponents/index.js'
import { isEmpty } from '@/dragComponents/utils'
import auth from '@/dragComponents/mixins/auth.js'

export default {
  name: 'data-report-detail',
  mixins: [auth],
  provide() {
    return {
      category: 'report',
      device: 'desktop'
    }
  },
  data() {
    return {
      loading: false,
      noAuth: false,
      data: {}
    }
  },
  computed: {
    styleNoAuth() {
      return {
        height: '200px',
        lineHeight: '200px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#999'
      }
    }
  },
  methods: {
    loadData() {
      let id = this.$route.query.id ? this.$route.query.id : null
      if (isEmpty(id)) return
      this.$http
        .get(`/data-report/model/${id}`)
        .then((res) => {
          if (res.code === 200) {
            const modelJsonMap = res.data.modelJsonMap
            this.data = modelJsonMap
          }
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          let isAuth = this.hasAuth(this.data)
          console.log('hasAuth==', isAuth, this.data.roleList, this.userRoles)
          if (isAuth) {
            this.loading = true
          } else {
            this.setRedirect(this.data.redirect)
          }
        })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
